import { Layout } from "antd";
import React from "react";
import { useIsMobile } from "../../hooks/useIsMobile";
import { MainContent } from "../main-content/MainContent";
import { AppSidebar, SIDEBAR_WIDTH } from "./AppSidebar";
import { AppTopbar } from "./AppTopbar";
import { BottomNav } from "./BottomNav";

// Authenticated app shell: sidebar + topbar on desktop, topbar + bottom
// navigation on mobile.
export const AppShell: React.FC<{ refetch: any }> = ({ refetch }) => {
  const isMobile = useIsMobile();

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {!isMobile && <AppSidebar refetch={refetch} />}
      <Layout style={{ marginLeft: isMobile ? 0 : SIDEBAR_WIDTH, minWidth: 0 }}>
        <AppTopbar />
        <MainContent />
      </Layout>
      {isMobile && <BottomNav refetch={refetch} />}
    </Layout>
  );
};
